// extracted by mini-css-extract-plugin
export default {"skeleton":"LoadingSkeleton_skeleton__iSnn7","shimmer":"LoadingSkeleton_shimmer__zrsn6"};